import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { ImageCarousel, CarouselInputs } from '../ImageCarousel/ImageCarousel';
import './SpectrumScholars.scss';

export const SpectrumScholars = ({ node }) => {
    const inputs: CarouselInputs = {
        id: node.id,
        title: node.field_component_title,
        body: node.field_text_content?.value,
        background: `dark-blue`,
        arrows: `small`,
        noPadding: true,
    };

    return (
        <ImageCarousel inputs={inputs}>
            {node.relationships?.field_carousel_items
                .filter((item) => item.field_text_content)
                .map((item, idx) => {
                    const gImage = getImage(
                        item.relationships.field_single_image?.localFile
                    );
                    return (
                        <div className="scholar-item" key={idx}>
                            <GatsbyImage
                                image={gImage}
                                alt={item.field_single_image?.alt}
                            />
                            <div>
                                <h3>{item.field_title}</h3>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.field_text_content.value,
                                    }}
                                ></div>
                            </div>
                        </div>
                    );
                })}
        </ImageCarousel>
    );
};
